module.exports = __webpack_public_path__ + "img/bulb-reset-image.c84f3754.png";